module.exports = __webpack_public_path__ + "img/head-side-cough.fd48f1a1.svg";